import { render, staticRenderFns } from "./DireccionIcired.vue?vue&type=template&id=a90fd2fc&scoped=true&"
import script from "./DireccionIcired.vue?vue&type=script&lang=js&"
export * from "./DireccionIcired.vue?vue&type=script&lang=js&"
import style0 from "./DireccionIcired.vue?vue&type=style&index=0&id=a90fd2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90fd2fc",
  null
  
)

export default component.exports